import {writable} from 'svelte/store';

const createStore = () => {
  const {subscribe, set, update} = writable([0]);

  const replace = (key) => {
    set([key]);
  };

  const append = (key) => {
    update((currentKeys) => {
      if (!currentKeys.includes(key)) {
        currentKeys.push(key);
      }

      return currentKeys;
    });
  };

  return {
    subscribe,
    replace,
    append
  };
};

export const sortKeysStore = createStore();
